var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',[_vm._v(_vm._s(_vm.field.field_name)+" ")]),_c('b-form-input',{class:['input-custom'],model:{value:(_vm.field.value),callback:function ($$v) {_vm.$set(_vm.field, "value", $$v)},expression:"field.value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }